import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { logging } from 'selenium-webdriver';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.sass']
})
export class WarningComponent implements OnInit, OnChanges {
  @Input() status: string;
  @Output() displayed: EventEmitter<any>;

  show = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.displayed = new EventEmitter();
  }

  ngOnInit() {}

  ngOnChanges() {
    if (this.status && this.status !== 'VALIDATED') {
      this.show = true;
    }

    if (
      this.router.url.indexOf('/onboarding') === 0 ||
      this.router.url.indexOf('/login') === 0
    ) {
      this.show = false;
    }

    this.displayed.emit(this.show);
  }
}
